import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';

export const DisclosureArrow = ({ className, onClick, open, svgClassName, ...extraProps }) => (
  <span
    {...extraProps}
    onClick={onClick}
    className={classNames('disclosure-arrow', className, {
      'disclosure-arrow--open': open,
    })}>
    <Isvg
      className={classNames('svg', svgClassName)}
      uniquifyIDs={false}
      src={require('static/design-system/icons/arrow-down-small.svg')}
    />
  </span>
);

DisclosureArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  open: PropTypes.bool,
  svgClassName: PropTypes.string,
};
